import styles from "./TextBanner.module.css";

const TextBanner = (props) => {
  return (
    <>
      <div
        className={styles.container}
        style={
          props.backgroundColor
            ? { backgroundColor: `${props.backgroundColor}` }
            : null
        }
      >
        {props.overlay ? (
          <div
            className={styles.overlay_image}
            style={props.overlay ? { opacity: `${props.overlay}%` } : null}
          ></div>
        ) : null}
        {props.backgroundUrl ? (
          <img className={styles.backgroundImage} src={props.backgroundUrl} />
        ) : null}
        <div className={styles.inner}>
          <div className={styles.vertical_center}>
            {props.title && <h1 className={styles.title}>{props.title}</h1>}
            {props.subtitle && (
              <h2 className={styles.subtitle}>{props.subtitle}</h2>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default TextBanner;
